export default __webpack_public_path__ + "media/images/iui/grayButton-4b1fbcecaf1af10df8a54b4436ff92b9.png";